import { render } from "./CalculatedTotalsComponent.vue?vue&type=template&id=727b1103"
import script from "./CalculatedTotalsComponent.vue?vue&type=script&lang=js"
export * from "./CalculatedTotalsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__